<app-modals [title]="title" [openModal]="openModal" [whenModalClose]="whenModalClose" [closeModal]="closeModal" [onDismiss]="onDismiss" [submitKey]="submitKey" [invalidFormGroup]="entry?.invalid" [isButtonsDisabled]="isButtonsDisabled" [showFooter]="!isSetup && isAvailable" [isShaking]="errors?.length > 0">
  <ng-container *ngIf="id && entry">
    <div class="row">
      <div class="col-12"><img class="mx-auto d-block" [src]="logo" width="150" />
        <p class="text-muted small" [innerHTML]="description | translate"></p>
      </div>
    </div>
    <hr />
    <div class="row text-center" *ngIf="isSetup">
      <div class="col-12 webhook-wrapper">
        <ng-container *ngIf="id == 'greenhouse'"><b class="small mt-4">{{ 'MODALS.INTEGRATIONS.WEBHOOK_URL' | translate }}</b>
          <div class="row" id="webhook">
            <div class="col-12">
              <p class="text-muted small" [innerHTML]="webhookUrl"></p>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="isSpongeIntegration && isLegacyConnected">
          <div class="alert alert-info small mt-4" id="legacy-connected">{{ 'MODALS.INTEGRATIONS.LEGACY_CONNECTED' | translate }}</div>
        </ng-container>

        <ng-container *ngIf="isSpongeIntegration && webhookUrl && id !== 'workable_webhook'"><b class="small mt-4">{{ 'MODALS.INTEGRATIONS.WEBHOOK_URL' | translate }}</b>
          <div class="row" id="webhook-url">
            <div class="col-12">
              <div class="input-group">
                <input class="form-control" type="text" readonly="readonly" [value]="webhookUrl" [attr.aria-label]="'MODALS.INTEGRATIONS.WEBHOOK_URL' | translate" />
                <div class="input-group-append">
                  <button class="btn btn-sm v-btn v-btn-light" type="button" (click)="copyWebhookUrl()" [attr.aria-label]="'MODALS.INTEGRATIONS.COPY_WEBHOOK_URL' | translate"><i class="lnr lnr-copy"></i></button>
                </div>
              </div>
              <p class="text-muted small mt-2">{{ 'MODALS.INTEGRATIONS.WEBHOOK_URL_HELP' | translate }}</p>
            </div>
          </div>
        </ng-container>

        <!-- Workable-specific webhook subscription status -->
        <ng-container *ngIf="id === 'workable_webhook'">
          <div *ngIf="hasWebhookSubscription" class="mt-3">
            <div class="alert alert-success small">
              <i class="lnr lnr-checkmark-circle mr-2"></i>
              {{ 'MODALS.INTEGRATIONS.WEBHOOK_SUBSCRIPTION_ACTIVE' | translate }}
            </div>
          </div>

          <!-- Workable Webhook Event Settings -->
          <div *ngIf="id === 'workable_webhook'" class="mt-4">
            <div *ngIf="isLoadingWebhookSettings" class="text-center py-3">
              <div class="spinner-border spinner-border-sm text-primary" role="status">
                <span class="sr-only">{{ 'COMMON.LOADING' | translate }}</span>
              </div>
              <small class="d-block mt-2 text-muted">{{ 'MODALS.INTEGRATIONS.WEBHOOKS.LOADING' | translate }}</small>
            </div>

            <div *ngIf="!isLoadingWebhookSettings && webhookSettings && webhookSettingsForm">
              <b class="small mt-4 d-block">{{ 'MODALS.INTEGRATIONS.WEBHOOKS.TITLE' | translate }}</b>
              <p class="text-muted small mb-3">{{ 'MODALS.INTEGRATIONS.WEBHOOKS.HELP' | translate }}</p>

              <form [formGroup]="webhookSettingsForm">
                <div class="card v-card mt-2 mb-3">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12 col-md-11">
                        <h6 class="card-title mb-1">{{ 'MODALS.INTEGRATIONS.WEBHOOKS.CANDIDATE_CREATED.TITLE' | translate }}</h6>
                        <small class="text-muted">{{ 'MODALS.INTEGRATIONS.WEBHOOKS.CANDIDATE_CREATED.HELP' | translate }}</small>
                      </div>
                      <div class="col-12 col-md-1 align-items-center d-flex">
                        <div class="btn-toolbar ms-auto me-0">
                          <ui-switch formControlName="candidate_created" (change)="onWebhookSettingChange()"></ui-switch>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card v-card mt-2 mb-3">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12 col-md-11">
                        <h6 class="card-title mb-1">{{ 'MODALS.INTEGRATIONS.WEBHOOKS.CANDIDATE_MOVED.TITLE' | translate }}</h6>
                        <small class="text-muted">{{ 'MODALS.INTEGRATIONS.WEBHOOKS.CANDIDATE_MOVED.HELP' | translate }}</small>
                      </div>
                      <div class="col-12 col-md-1 align-items-center d-flex">
                        <div class="btn-toolbar ms-auto me-0">
                          <ui-switch formControlName="candidate_moved" (change)="onWebhookSettingChange()"></ui-switch>
                        </div>
                      </div>
                    </div>

                    <!-- Stage checkboxes - only shown when candidate_moved is enabled -->
                    <div *ngIf="webhookSettingsForm.get('candidate_moved')?.value" class="row mt-3 pt-3" style="border-top: 1px solid #e0e0e0;">
                      <div class="col-12">
                        <small class="text-muted d-block mb-2"><strong>{{ 'MODALS.INTEGRATIONS.WEBHOOKS.SELECT_STAGES' | translate }}</strong></small>

                        <div *ngIf="isLoadingStages" class="text-center py-3">
                          <div class="spinner-border spinner-border-sm text-primary" role="status">
                            <span class="sr-only">{{ 'MODALS.INTEGRATIONS.WEBHOOKS.LOADING_STAGES' | translate }}</span>
                          </div>
                          <small class="d-block mt-2 text-muted">{{ 'MODALS.INTEGRATIONS.WEBHOOKS.LOADING_STAGES' | translate }}</small>
                        </div>

                        <div *ngIf="!isLoadingStages" class="row">
                          <div class="col-12 col-md-6" *ngFor="let stage of workableStages">
                            <div class="form-check mb-2">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                [id]="'stage_' + stage"
                                [value]="stage"
                                [checked]="isStageEnabled(stage)"
                                (change)="onStageToggle(stage, $event)"
                              />
                              <label class="form-check-label" [for]="'stage_' + stage">
                                {{ stageLabel(stage) }}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card v-card mt-2 mb-3">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12 col-md-11">
                        <h6 class="card-title mb-1">{{ 'MODALS.INTEGRATIONS.WEBHOOKS.CANDIDATE_DELETED.TITLE' | translate }}</h6>
                        <small class="text-muted">{{ 'MODALS.INTEGRATIONS.WEBHOOKS.CANDIDATE_DELETED.HELP' | translate }}</small>
                      </div>
                      <div class="col-12 col-md-1 align-items-center d-flex">
                        <div class="btn-toolbar ms-auto me-0">
                          <ui-switch formControlName="candidate_deleted" (change)="onWebhookSettingChange()"></ui-switch>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Default Recruiter Assignment -->
                <div class="card v-card mt-2 mb-3">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12">
                        <h6 class="card-title mb-1">{{ 'MODALS.INTEGRATIONS.WEBHOOKS.DEFAULT_RECRUITER.TITLE' | translate }}</h6>
                        <small class="text-muted d-block mb-3">{{ 'MODALS.INTEGRATIONS.WEBHOOKS.DEFAULT_RECRUITER.HELP' | translate }}</small>

                        <div *ngIf="isLoadingRecruiters" class="text-center py-3">
                          <div class="spinner-border spinner-border-sm text-primary" role="status">
                            <span class="sr-only">{{ 'MODALS.INTEGRATIONS.WEBHOOKS.DEFAULT_RECRUITER.LOADING' | translate }}</span>
                          </div>
                        </div>

                        <div *ngIf="!isLoadingRecruiters">
                          <select
                            class="form-control"
                            formControlName="default_recruiter_id"
                            (change)="onDefaultRecruiterChange()"
                          >
                            <option *ngFor="let recruiter of recruiters" [value]="recruiter.id">
                              {{ recruiter.user.first_name }} {{ recruiter.user.last_name }} ({{ recruiter.user.email }})<ng-container *ngIf="recruiter.is_default_root"> {{ 'MODALS.INTEGRATIONS.WEBHOOKS.DEFAULT_RECRUITER.DEFAULT_ADMIN' | translate }}</ng-container>
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <hr class="my-4" />
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="isSpongeIntegration && embedUrl"><b class="small mt-4">{{ 'MODALS.INTEGRATIONS.EMBED_URL' | translate }}</b>
          <div class="row" id="embed-url">
            <div class="col-12">
              <div class="input-group">
                <input class="form-control" type="text" readonly="readonly" [value]="embedUrl" [attr.aria-label]="'MODALS.INTEGRATIONS.EMBED_URL' | translate" />
                <div class="input-group-append">
                  <button class="btn btn-sm v-btn v-btn-light" type="button" (click)="copyEmbedUrl()" [attr.aria-label]="'MODALS.INTEGRATIONS.COPY_EMBED_URL' | translate"><i class="lnr lnr-copy"></i></button>
                </div>
              </div>
              <p class="text-muted small mt-2">{{ 'MODALS.INTEGRATIONS.EMBED_URL_HELP' | translate }}</p>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="isSpongeIntegration && cardUrl"><b class="small mt-4">{{ 'MODALS.INTEGRATIONS.CARD_URL' | translate }}</b>
          <div class="row" id="card-url">
            <div class="col-12">
              <div class="input-group">
                <input class="form-control" type="text" readonly="readonly" [value]="cardUrl" [attr.aria-label]="'MODALS.INTEGRATIONS.CARD_URL' | translate" />
                <div class="input-group-append">
                  <button class="btn btn-sm v-btn v-btn-light" type="button" (click)="copyCardUrl()" [attr.aria-label]="'MODALS.INTEGRATIONS.COPY_CARD_URL' | translate"><i class="lnr lnr-copy"></i></button>
                </div>
              </div>
              <p class="text-muted small mt-2">{{ 'MODALS.INTEGRATIONS.CARD_URL_HELP' | translate }}</p>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="isSpongeIntegration && menuUrl"><b class="small mt-4">{{ 'MODALS.INTEGRATIONS.MENU_URL' | translate }}</b>
          <div class="row" id="menu-url">
            <div class="col-12">
              <div class="input-group">
                <input class="form-control" type="text" readonly="readonly" [value]="menuUrl" [attr.aria-label]="'MODALS.INTEGRATIONS.MENU_URL' | translate" />
                <div class="input-group-append">
                  <button class="btn btn-sm v-btn v-btn-light" type="button" (click)="copyMenuUrl()" [attr.aria-label]="'MODALS.INTEGRATIONS.COPY_MENU_URL' | translate"><i class="lnr lnr-copy"></i></button>
                </div>
              </div>
              <p class="text-muted small mt-2">{{ 'MODALS.INTEGRATIONS.MENU_URL_HELP' | translate }}</p>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="isSpongeIntegration && listActionUrl"><b class="small mt-4">{{ 'MODALS.INTEGRATIONS.LIST_URL' | translate }}</b>
          <div class="row" id="list-url">
            <div class="col-12">
              <div class="input-group">
                <input class="form-control" type="text" readonly="readonly" [value]="listActionUrl" [attr.aria-label]="'MODALS.INTEGRATIONS.LIST_URL' | translate" />
                <div class="input-group-append">
                  <button class="btn btn-sm v-btn v-btn-light" type="button" (click)="copyListActionUrl()" [attr.aria-label]="'MODALS.INTEGRATIONS.COPY_LIST_URL' | translate"><i class="lnr lnr-copy"></i></button>
                </div>
              </div>
              <p class="text-muted small mt-2">{{ 'MODALS.INTEGRATIONS.LIST_URL_HELP' | translate }}</p>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="supportsDiagnostics">
          <div class="text-start mt-4" id="diagnostics">
            <b class="small">{{ 'MODALS.INTEGRATIONS.DIAGNOSTICS.TITLE' | translate }}</b>
            <p class="text-muted small">{{ 'MODALS.INTEGRATIONS.DIAGNOSTICS.HELP' | translate }}</p>
            <button class="btn v-btn v-btn-light" type="button" id="run-diagnostics" (click)="runDiagnostics()" [disabled]="isDiagnosticsRunning" [attr.aria-busy]="isDiagnosticsRunning">
              <span *ngIf="isDiagnosticsRunning" class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
              {{ (isDiagnosticsRunning ? 'MODALS.INTEGRATIONS.DIAGNOSTICS.RUNNING' : 'MODALS.INTEGRATIONS.DIAGNOSTICS.RUN') | translate }}
            </button>
            <div *ngIf="diagnosticsError" class="alert alert-danger small mt-3" role="alert" id="diagnostics-error">{{ diagnosticsError }}</div>
            <div *ngIf="diagnostics">
              <div class="alert small mt-3" role="status" id="diagnostics-overall" [ngClass]="diagnosticsAlertClass(diagnostics.overall)">{{ 'MODALS.INTEGRATIONS.DIAGNOSTICS.OVERALL.' + diagnostics.overall.toUpperCase() | translate }}</div>
              <ul class="list-group list-group-flush" id="diagnostics-probes">
                <li *ngFor="let probe of diagnostics.probes" class="list-group-item px-0 d-flex align-items-start" [attr.data-probe]="probe.key" [attr.data-status]="probe.status">
                  <span class="badge me-2 mt-1" [ngClass]="probeBadgeClass(probe.status)">{{ 'MODALS.INTEGRATIONS.DIAGNOSTICS.STATUS.' + probe.status.toUpperCase() | translate }}</span>
                  <div>
                    <div class="small fw-bold">{{ probeLabel(probe) }}</div>
                    <div *ngIf="probe.detail" class="small text-muted text-break">{{ probe.detail }}</div>
                    <div *ngIf="probe.remediation" class="small">{{ probe.remediation }}</div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="col-12"><button class="btn v-btn-danger" (click)="delete()">{{ 'INTEGRATIONS.DELETE' | translate }}</button></div>
    </div>

    <div class="row" *ngIf="!isSetup">
      <div class="col-12">
        <form #entityForm="ngForm" [formGroup]="entry" (ngSubmit)="onSubmit(entry)" novalidate="novalidate">
          <ng-container [ngSwitch]="isSpongeIntegration ? 'sponge' : id">
            <ng-container *ngSwitchCase="'erecruit'">
              <div class="row">
                <div class="col-12">
                  <app-forms-form-group [value]="entry.get('site_url')" fieldName="site_url" [fieldLabel]="'INTEGRATIONS.SITE_URL' | translate"><input class="form-control" id="site_url" type="text" autocomplete="site_url" formControlName="site_url" placeholder="site_url" appAutoFocus="appAutoFocus" /></app-forms-form-group>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-md-6">
                  <app-forms-form-group [value]="entry.get('department_id')" fieldName="department_id" [fieldLabel]="'INTEGRATIONS.DEPARTMENT_ID' | translate"><input class="form-control" id="department_id" type="text" autocomplete="department_id" formControlName="department_id" placeholder="department_id" /></app-forms-form-group>
                </div>

                <div class="col-12 col-md-6">
                  <app-forms-form-group [value]="entry.get('attachment_type_id')" fieldName="attachment_type_id" [fieldLabel]="'INTEGRATIONS.ATTACHMENT_TYPE_ID' | translate"><input class="form-control" id="attachment_type_id" type="text" autocomplete="attachment_type_id" formControlName="attachment_type_id" placeholder="attachment_type_id" /></app-forms-form-group>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-md-6">
                  <app-forms-form-group [value]="entry.get('folder_group_id')" fieldName="folder_group_id" [fieldLabel]="'INTEGRATIONS.FOLDER_GROUP_ID' | translate"><input class="form-control" id="folder_group_id" type="number" autocomplete="folder_group_id" placeholder="folder_group_id" formControlName="folder_group_id" /></app-forms-form-group>
                </div>

                <div class="col-12 col-md-6">
                  <app-forms-form-group [value]="entry.get('ad_source_id')" fieldName="ad_source_id" [fieldLabel]="'INTEGRATIONS.AD_SOURCE_ID' | translate"><input class="form-control" id="ad_source_id" type="number" autocomplete="ad_source_id" placeholder="ad_source_id" formControlName="ad_source_id" /></app-forms-form-group>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-md-6">
                  <app-forms-form-group [value]="entry.get('requirement_id')" fieldName="requirement_id" [fieldLabel]="'INTEGRATIONS.REQUIREMENT_ID' | translate"><input class="form-control" id="requirement_id" type="text" autocomplete="requirement_id" placeholder="requirement_id" formControlName="requirement_id" /></app-forms-form-group>
                </div>

                <div class="col-12 col-md-6">
                  <app-forms-form-group [value]="entry.get('status_id')" fieldName="status_id" [fieldLabel]="'INTEGRATIONS.STATUS_ID' | translate"><input class="form-control" id="status_id" type="number" autocomplete="status_id" placeholder="status_id" formControlName="status_id" /></app-forms-form-group>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-md-6">
                  <app-forms-form-group [value]="entry.get('client_id')" fieldName="client_id" [fieldLabel]="'INTEGRATIONS.CLIENT_ID' | translate"><input class="form-control" id="client_id" type="text" autocomplete="client_id" placeholder="client_id" formControlName="client_id" /></app-forms-form-group>
                </div>

                <div class="col-12 col-md-6">
                  <app-forms-form-group [value]="entry.get('client_secret')" fieldName="client_secret" [fieldLabel]="'INTEGRATIONS.CLIENT_SECRET' | translate"><input class="form-control" id="client_secret" type="password" autocomplete="client_secret" placeholder="client_secret" formControlName="client_secret" /></app-forms-form-group>
                </div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'bullhorn'">
              <div class="row">
                <div class="col-12 col-md-6">
                  <app-forms-form-group [value]="entry.get('client_id')" fieldName="client_id" [fieldLabel]="'INTEGRATIONS.CLIENT_ID' | translate"><input class="form-control" id="client_id" type="text" autocomplete="client_id" formControlName="client_id" placeholder="client_id" appAutoFocus="appAutoFocus" /></app-forms-form-group>
                </div>

                <div class="col-12 col-md-6">
                  <app-forms-form-group [value]="entry.get('client_secret')" fieldName="client_secret" [fieldLabel]="'INTEGRATIONS.CLIENT_SECRET' | translate"><input class="form-control" id="client_secret" type="password" autocomplete="client_secret" placeholder="client_secret" formControlName="client_secret" /></app-forms-form-group>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-md-6">
                  <app-forms-form-group [value]="entry.get('username')" fieldName="username" [fieldLabel]="'INTEGRATIONS.USERNAME' | translate"><input class="form-control" id="username" type="text" autocomplete="username" placeholder="username" formControlName="username" /></app-forms-form-group>
                </div>

                <div class="col-12 col-md-6">
                  <app-forms-form-group [value]="entry.get('password')" fieldName="password" [fieldLabel]="'COMMON.PASSWORD' | translate"><input class="form-control" id="password" type="password" autocomplete="password" placeholder="password" formControlName="password" /></app-forms-form-group>
                </div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'jobdiva'">
              <app-forms-form-group [value]="entry.get('client_id')" fieldName="client_id" [fieldLabel]="'INTEGRATIONS.CLIENT_ID' | translate"><input class="form-control" id="client_id" type="text" autocomplete="client_id" formControlName="client_id" placeholder="client_id" appAutoFocus="appAutoFocus" /></app-forms-form-group>

              <div class="row">
                <div class="col-12 col-md-6">
                  <app-forms-form-group [value]="entry.get('username')" fieldName="username" [fieldLabel]="'INTEGRATIONS.USERNAME' | translate"><input class="form-control" id="username" type="text" autocomplete="username" placeholder="username" formControlName="username" /></app-forms-form-group>
                </div>

                <div class="col-12 col-md-6">
                  <app-forms-form-group [value]="entry.get('password')" fieldName="password" [fieldLabel]="'COMMON.PASSWORD' | translate"><input class="form-control" id="password" type="password" autocomplete="password" placeholder="password" formControlName="password" /></app-forms-form-group>
                </div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'target_recruit'">
              <app-forms-form-group [value]="entry.get('site_url')" fieldName="site_url" [fieldLabel]="'INTEGRATIONS.SITE_URL' | translate"><input class="form-control" id="site_url" type="text" autocomplete="site_url" formControlName="site_url" placeholder="site_url" appAutoFocus="appAutoFocus" /></app-forms-form-group>

              <div class="row">
                <div class="col-12 col-md-6">
                  <app-forms-form-group [value]="entry.get('security_token')" fieldName="security_token" [fieldLabel]="'INTEGRATIONS.SECURITY_TOKEN' | translate" [isRequired]="false"><input class="form-control" id="security_token" type="string" autocomplete="security_token" placeholder="security_token" formControlName="security_token" /></app-forms-form-group>
                </div>

                <div class="col-12 col-md-6">
                  <app-forms-form-group [value]="entry.get('candidate_record_type_id')" fieldName="candidate_record_type_id" [fieldLabel]="'INTEGRATIONS.CANDIDATE_RECORD_TYPE_ID' | translate"><input class="form-control" id="candidate_record_type_id" type="string" autocomplete="candidate_record_type_id" placeholder="candidate_record_type_id" formControlName="candidate_record_type_id" /></app-forms-form-group>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-md-6">
                  <app-forms-form-group [value]="entry.get('client_id')" fieldName="client_id" [fieldLabel]="'INTEGRATIONS.CLIENT_ID' | translate"><input class="form-control" id="client_id" type="text" autocomplete="client_id" placeholder="client_id" formControlName="client_id" /></app-forms-form-group>
                </div>

                <div class="col-12 col-md-6">
                  <app-forms-form-group [value]="entry.get('client_secret')" fieldName="client_secret" [fieldLabel]="'INTEGRATIONS.CLIENT_SECRET' | translate"><input class="form-control" id="client_secret" type="password" autocomplete="client_secret" placeholder="client_secret" formControlName="client_secret" /></app-forms-form-group>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-md-6">
                  <app-forms-form-group [value]="entry.get('username')" fieldName="username" [fieldLabel]="'INTEGRATIONS.USERNAME' | translate"><input class="form-control" id="username" type="text" autocomplete="username" placeholder="username" formControlName="username" /></app-forms-form-group>
                </div>

                <div class="col-12 col-md-6">
                  <app-forms-form-group [value]="entry.get('password')" fieldName="password" [fieldLabel]="'COMMON.PASSWORD' | translate"><input class="form-control" id="password" type="password" autocomplete="password" placeholder="password" formControlName="password" /></app-forms-form-group>
                </div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'greenhouse'">
              <app-forms-form-group [value]="entry.get('site_url')" fieldName="site_url" [fieldLabel]="'INTEGRATIONS.SITE_URL' | translate"><input class="form-control" id="site_url" type="text" autocomplete="site_url" formControlName="site_url" placeholder="site_url" appAutoFocus="appAutoFocus" /></app-forms-form-group>

              <div class="row">
                <div class="col-12 col-md-6">
                  <app-forms-form-group [value]="entry.get('user_id')" fieldName="user_id" [fieldLabel]="'INTEGRATIONS.USER_ID' | translate"><input class="form-control" id="client_id" type="text" autocomplete="user_id" placeholder="user_id" formControlName="user_id" /></app-forms-form-group>
                </div>

                <div class="col-12 col-md-6">
                  <app-forms-form-group [value]="entry.get('api_key')" fieldName="api_key" [fieldLabel]="'INTEGRATIONS.API_KEY' | translate"><input class="form-control" id="client_secret" type="text" autocomplete="api_key" placeholder="api_key" formControlName="api_key" /></app-forms-form-group>
                </div>
              </div>
            </ng-container>

            <!-- Dynamic form generation for Sponge integrations -->
            <ng-container *ngSwitchDefault>
              <ng-container *ngIf="isSpongeIntegration && spongeConfig">
                <div class="row" *ngFor="let credential of spongeConfig.authentication.credentials">
                  <div class="col-12">
                    <app-forms-form-group
                      [value]="entry.get(credential.name)"
                      [fieldName]="credential.name"
                      [fieldLabel]="credentialLabel(credential)"
                      [isRequired]="credential.required"
                      [errors]="credential.name === 'subdomain' ? [{ field: 'required', label: 'FORMS.ERRORS.REQUIRED' }] : undefined">
                      <input
                        class="form-control"
                        [id]="credential.name"
                        [type]="credential.type === 'password' || credential.secure ? 'password' : 'text'"
                        [autocomplete]="credential.name"
                        [formControlName]="credential.name"
                        [placeholder]="credentialHelp(credential) || credentialLabel(credential)"
                      />
                    </app-forms-form-group>

                    <!-- Help text for API Access Token -->
                    <div *ngIf="credential.name === 'access_token'" class="alert alert-info small mt-2 mb-3">
                      <strong>{{ 'MODALS.INTEGRATIONS.SPONGE.ACCESS_TOKEN_HOWTO.TITLE' | translate }}</strong> {{ 'MODALS.INTEGRATIONS.SPONGE.ACCESS_TOKEN_HOWTO.TEXT' | translate }}
                    </div>

                    <!-- Help text for Account Subdomain -->
                    <div *ngIf="credential.name === 'subdomain'" class="alert alert-info small mt-2 mb-3">
                      <strong>{{ 'MODALS.INTEGRATIONS.SPONGE.SUBDOMAIN_HOWTO.TITLE' | translate }}</strong> {{ 'MODALS.INTEGRATIONS.SPONGE.SUBDOMAIN_HOWTO.TEXT' | translate }}
                    </div>

                    <!-- Custom error message below the subdomain field -->
                    <div *ngIf="credential.name === 'subdomain' && entry.get('subdomain')?.invalid && entry.get('subdomain')?.touched && entry.get('subdomain')?.value && entry.get('subdomain')?.hasError('subdomain')" class="alert alert-danger small mt-2 mb-3 fadeIn">
                      <i class="lnr lnr-warning mr-2"></i>
                      <span>{{ 'MODALS.INTEGRATIONS.SPONGE.SUBDOMAIN_INVALID' | translate }}</span>
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        </form>
      </div>
    </div>
  </ng-container>
</app-modals>
